import { BaseInfoCard, baseCardStyles } from "./base-info-card.js";

const template = document.createElement("template");

template.innerHTML = `
  <style>
    ${baseCardStyles}

    .icon-container {
      border-radius: 9999px;
      background-color: color-mix(in srgb, var(--p-green-500, #22c55e) 12%, transparent);
      color: var(--p-green-600, #16a34a);
    }

    :host-context(.app-dark) .icon-container,
    :host-context(.dark) .icon-container,
    :host-context(.p-dark) .icon-container,
    :host-context([data-theme="dark"]) .icon-container,
    :host-context([theme="dark"]) .icon-container,
    :host([theme="dark"]) .icon-container {
      background-color: color-mix(in srgb, var(--p-green-400, #4ade80) 20%, transparent);
      color: var(--p-green-400, #4ade80);
    }

    .card-value {
      color: var(--p-green-600, #16a34a);
    }

    :host-context(.app-dark) .card-value,
    :host-context(.dark) .card-value,
    :host-context(.p-dark) .card-value,
    :host-context([data-theme="dark"]) .card-value,
    :host-context([theme="dark"]) .card-value,
    :host([theme="dark"]) .card-value {
      color: var(--p-green-400, #4ade80);
    }

    .card-bottom {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 0.5rem;
      flex-wrap: wrap;
    }

    .manager-count {
      font-size: 0.875rem;
      font-weight: 700;
      color: var(--p-green-600, #16a34a);
    }

    :host-context(.app-dark) .manager-count,
    :host-context(.dark) .manager-count,
    :host-context(.p-dark) .manager-count,
    :host-context([data-theme="dark"]) .manager-count,
    :host-context([theme="dark"]) .manager-count,
    :host([theme="dark"]) .manager-count {
      color: var(--p-green-400, #4ade80);
    }

    .optout-count {
      font-size: 0.8125rem;
      font-weight: 600;
      color: var(--p-red-500, #ef4444);
    }

    :host-context(.app-dark) .optout-count,
    :host-context(.dark) .optout-count,
    :host-context(.p-dark) .optout-count,
    :host-context([data-theme="dark"]) .optout-count,
    :host-context([theme="dark"]) .optout-count,
    :host([theme="dark"]) .optout-count {
      color: var(--p-red-400, #f87171);
    }
  </style>

  <div class="info-card" id="card" data-route="/hr/employees">
    <div class="card-top">
      <div class="icon-container">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round">
          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/>
          <circle cx="9" cy="7" r="4"/>
          <path d="M22 21v-2a4 4 0 0 0-3-3.87"/>
          <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
        </svg>
      </div>
      <div class="card-body">
        <h3 class="card-title" id="title">עובדים</h3>
        <div class="card-value" id="value">0</div>
        <p class="card-subtitle" id="subtitle">סה״כ עובדים</p>
      </div>
    </div>
    <div class="card-divider"></div>
    <div class="card-bottom">
      <span class="manager-count" id="managerCount">0 מנהלים</span>
      <span class="optout-count" id="optoutCount">0 טרם אישרו</span>
    </div>
  </div>
`;

class EmployeesCard extends BaseInfoCard {
  constructor() {
    super(template);
  }

  get defaultRoute() {
    return "/hr/employees";
  }

  render() {
    const titleEl = this.shadowRoot.getElementById("title");
    const valueEl = this.shadowRoot.getElementById("value");
    const subtitleEl = this.shadowRoot.getElementById("subtitle");
    const managerCountEl = this.shadowRoot.getElementById("managerCount");
    const optoutCountEl = this.shadowRoot.getElementById("optoutCount");

    if (!titleEl || !valueEl || !subtitleEl || !managerCountEl || !optoutCountEl) return;

    const isHebrew = this.isHebrew;
    const services = this._data?.services || [];
    const manageUsersService = services.find(s => s.serviceKey === "manageusers");
    const muState = manageUsersService?.state || {};

    const employeesList = muState.employees || [];
    const totalEmployees = muState.employeeCount ?? muState.totalEmployees ?? employeesList.length;

    let managerCount = 0;
    let optoutCount = 0;

    if (Array.isArray(employeesList)) {
      employeesList.forEach(emp => {
        const role = String(emp.role || "").toLowerCase();
        if (role.includes("manager") || role.includes("owner") || emp.isManager) {
          managerCount++;
        }
        if (emp.privacyApproved === false || emp.privacy_approved === false || emp.wa_opt_in === false) {
          optoutCount++;
        }
      });
    }

    if (muState.managerCount !== undefined) {
      managerCount = muState.managerCount;
    }

    titleEl.textContent = isHebrew ? "עובדים" : "Employees";
    valueEl.textContent = `${totalEmployees}`;
    subtitleEl.textContent = isHebrew ? "סה״כ עובדים" : "Total employees";

    managerCountEl.textContent = isHebrew
      ? `${managerCount} מנהלים`
      : `${managerCount} managers`;

    if (optoutCount > 0) {
      optoutCountEl.style.display = "inline";
      optoutCountEl.textContent = isHebrew
        ? `${optoutCount} טרם אישרו`
        : `${optoutCount} opted out`;
    } else {
      optoutCountEl.style.display = "none";
    }
  }
}

if (!customElements.get("employees-card")) {
  customElements.define("employees-card", EmployeesCard);
}

export { EmployeesCard };
